import { type IncidentReport, IncidentStatus } from '@lmc/ts-common'
import dayjs from 'dayjs'
import type { ReactNode } from 'react'

type ViewCaseItem = { key: string; label: ReactNode; children: ReactNode }

export const tagColorMap = {
  [IncidentStatus.closed]: undefined,
  [IncidentStatus.needsReview]: 'red',
  [IncidentStatus.open]: 'blue'
}

export const filterItems = (items: Array<ViewCaseItem | null | undefined>) => {
  return items?.filter((item) => item && !!item.children)
}

export const getCombinedTimeIso = (
  dateValue: dayjs.Dayjs,
  timeValue: dayjs.Dayjs
) => {
  const datePart = dayjs(dateValue).format('YYYY-MM-DD')
  const timePart = dayjs(timeValue).format('HH:mm:ss')
  return dayjs(`${datePart}T${timePart}`).toISOString()
}

export const containsImageExtension = (url: string) => {
  return /\.(jpg|jpeg|png|gif)/i.test(url)
}

export const containsVideoExtension = (url: string) => {
  return /\.(mp4|webm|ogg|mov)/i.test(url)
}

export const getPdfTitle = (
  incidentReport: IncidentReport,
  incidentCaseString: string
) => {
  return `${incidentReport.serviceUser.name}'s ${incidentReport.log.title} ${incidentCaseString}`
}
